/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditEventSource } from './AuditEventSource';
import {
    AuditEventSourceFromJSON,
    AuditEventSourceFromJSONTyped,
    AuditEventSourceToJSON,
    AuditEventSourceToJSONTyped,
} from './AuditEventSource';

/**
 * 
 * @export
 * @interface AuditEventSourceCountResponse
 */
export interface AuditEventSourceCountResponse {
    /**
     * 
     * @type {AuditEventSource}
     * @memberof AuditEventSourceCountResponse
     */
    source?: AuditEventSource;
    /**
     * 
     * @type {any}
     * @memberof AuditEventSourceCountResponse
     */
    count?: any | null;
}



/**
 * Check if a given object implements the AuditEventSourceCountResponse interface.
 */
export function instanceOfAuditEventSourceCountResponse(value: object): value is AuditEventSourceCountResponse {
    return true;
}

export function AuditEventSourceCountResponseFromJSON(json: any): AuditEventSourceCountResponse {
    return AuditEventSourceCountResponseFromJSONTyped(json, false);
}

export function AuditEventSourceCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventSourceCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'] == null ? undefined : AuditEventSourceFromJSON(json['source']),
        'count': json['count'] === undefined ? undefined : json['count'] === null ? null : json['count'],
    };
}

export function AuditEventSourceCountResponseToJSON(json: any): AuditEventSourceCountResponse {
    return AuditEventSourceCountResponseToJSONTyped(json, false);
}

export function AuditEventSourceCountResponseToJSONTyped(value?: AuditEventSourceCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': AuditEventSourceToJSON(value['source']),
        'count': value['count'],
    };
}

